import styled from 'styled-components';
import { Modal } from '@interstate/components/Modal';

export const StyledModal = styled(Modal)`
    max-width: 720px;
    min-width: 432px;
    margin: 0 auto;
`;

export const ModalBody = styled.div`
    padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
    margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const ScenarioList = styled.div`
    background-color: ${({ theme }) => theme.tokens.BaseColorGray50};
    border-radius: ${({ theme }) => theme.spacing(0.5)};
    padding: 0 ${({ theme }) => theme.spacing(1)};
    margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const ScenarioItem = styled.div<{ $isLast: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.spacing(1)} 0`};
    border-bottom: ${({ theme, $isLast }) => ($isLast ? 'none' : `1px solid ${theme.tokens.BaseColorGray300}`)};
`;

export const VehicleLabel = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
    white-space: nowrap;
`;

export const InfoIcon = styled.div`
    cursor: pointer;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.tokens.BaseColorBlue500};
`;
